import $ from 'jquery';
import RevealWhenVisible from '../../components/reveal-when-visible';
import InlineVideo from '../../components/inline-video';
import ResponsiveVideo from '../../components/responsive-video';
$(() => {
    InlineVideo.init();
    ResponsiveVideo.init();
    RevealWhenVisible.init();
});
